import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  RadioGroup,
  Radio,
  VStack,
  HStack,
  IconButton,
  useToast,
  Text,
  Flex,
  Image,
  Switch,
} from "@chakra-ui/react";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { ArrowDownIcon } from "@chakra-ui/icons";
import { getApi } from "common/services/api";
import { constant } from "common/constant";
import { postApi, putApi } from "common/services/api";
import BackIcon from "common/assets/img/BackIcon.png";
import EditIcon from "common/assets/img/editIcon.png";
import CopyIcon from "common/assets/img/copyIconDark.png";
import DeleteIcon from "common/assets/img/deleteIcon.png";
import DynamicFormModal from "common/components/dynamicFormModal";
import { createTaskRuleFields as baseTaskFields } from "common/constant";
import { workflowOptions } from "common/constant";
import DymanicTableModal from "common/components/dynamicTableModal";
import { createNewTemplateFields as baseFields } from "common/constant";

const CreateWorkflowRule = () => {
  let title = "worklfowActions";
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const toast = useToast();
  const isEditMode = Boolean(id || location.state?.id);
  const workflowId = id || location.state?.id;

  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [editableTitle, setEditableTitle] = useState("");
  const [editableDescription, setEditableDescription] = useState("");

  const [isOpen, setIsOpen] = useState(false);
  const [isTableModalOpen, setIsTableModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    ruleName: "",
    when: "",
    moduleName: "",
    conditions: [],
    actions: [],
  });
  const [originalWorkflowData, setOriginalWorkflowData] = useState(null);
  const [moduleFields, setModuleFields] = useState([]);
  const [conditionOption, setConditionOption] = useState("all");
  const [editActionIndex, setEditActionIndex] = useState(null);
  const [pendingActionType, setPendingActionType] = useState(null);
  const [isConditionSelected, setIsConditionSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [showActions, setShowActions] = useState(false);
  const [conditionsWithOperators, setConditionsWithOperators] = useState([
    {
      condition: { fieldName: "", operator: "", value: "" },
      logicalOperator: null,
    },
  ]);
  const [editModeEmailData, setEditModeEmailData] = useState(null);
  const [currentPage, setCurrentPage] = useState(() => {
    const paginationState = JSON.parse(localStorage.getItem("paginationState"));
    return paginationState?.pageName === title && paginationState?.currentPage
      ? paginationState.currentPage
      : 1;
  });

  const [pageSize, setPageSize] = useState(() => {
    const paginationState = JSON.parse(localStorage.getItem("paginationState"));
    return paginationState?.pageName === title && paginationState?.pageSize
      ? paginationState.pageSize
      : 10;
  });
  const [searchbox, setSearchbox] = useState(null);

  const [sortColumn, setSortColumn] = useState(null)
  const [sortOrder, setSortOrder] = useState('')
  const [selectedEmailRows, setSelectedEmailRows] = useState([]);
  const [emailTableData, setEmailTableData] = useState([]);
  const [associatedEmailNotifications, setAssociatedEmailNotifications] = useState([]);

  const workflowRule = JSON.parse(localStorage.getItem("workflowRuleData")) || {
    ruleName: isEditMode ? "Edit Workflow Rule" : "Create Workflow Rule",
    module: "",
    description: "",
  };
  const [fields, setFields] = useState(baseFields);
  const [taskFields, setTaskFields] = useState(baseTaskFields);
  const [metadata, setMetadata] = useState({});
  const user = JSON.parse(localStorage.getItem("user"));

  // Function to convert plural module names to singular for API calls
  const getModuleNameForAPI = (moduleName) => {
    const moduleMapping = {
      'leads': 'Leads',
      'contacts': 'Contacts',
      'accounts': 'Accounts',
      'Account': 'Accounts',
      'deals': 'Deals',
      'products': 'Products',

    };

    return moduleMapping[moduleName] || moduleName;
  };

  const fetchModuleFields = async (moduleName) => {
    try {
      let fields = [];

      if (moduleName === "Tasks") {
        fields = [
          { name: "taskName", label: "Task Name", type: "text" },
          { name: "priority", label: "Priority", type: "select", options: ["low", "medium", "high"] },
          { name: "dueDate", label: "Due Date", type: "date" },
        ];
      } else if (moduleName === "Meetings") {
        fields = [
          { name: "location", label: "Location", type: "text" },
          { name: "meetingName", label: "Meeting Name", type: "text" },
          { name: "dateTime", label: "Date & Time", type: "datetime-local" },
        ];
      } else if (moduleName === "Calls") {
        fields = [
          { name: "callSubject", label: "Call Subject", type: "text" },
          { name: "callType", label: "Call Type", type: "select", options: ["inbound", "outbound"] },
          { name: "dateTime", label: "Date & Time", type: "datetime-local" },
        ];
      } else if (moduleName) {
        const singularModuleName = getModuleNameForAPI(moduleName);

        const result = await getApi(`api/custom-field/?moduleName=${singularModuleName}`);
        fields = result.data[0]?.fields || [];
      }

      setModuleFields(fields);
    } catch (error) {
      console.error("Failed to fetch module fields:", error);
      setModuleFields([]);
    }
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";

    try {
      const date = new Date(dateString);

      if (isNaN(date.getTime())) {
        console.warn("Invalid date string:", dateString);
        return "";
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;
      return formattedDate;
    } catch (error) {
      console.error("Error formatting date for input:", error);
      return "";
    }
  };

  const formatDateForAPI = (dateString) => {
    if (!dateString) return "";

    try {
      const date = new Date(dateString);

      if (isNaN(date.getTime())) {
        console.warn("Invalid date string for API:", dateString);
        return "";
      }

      const isoString = date.toISOString();
      return isoString;
    } catch (error) {
      console.error("Error formatting date for API:", error);
      return "";
    }
  };

  const transformActionsToFormData = (actions) => {
    if (!actions || !Array.isArray(actions)) {
      return [];
    }


    return actions.map((action) => {
      switch (action.type) {
        case 'task_creation':
          const taskData = {
            title: action.taskConfig?.title || action.taskConfig?.taskName || "",
            description: action.taskConfig?.description || "",
            priority: action.taskConfig?.priority || "medium",
            dueDate: formatDateForInput(action.taskConfig?.dueDate || ""), // This is the key fix
            assignedTo: action.taskConfig?.assignedTo || "",
          };
          return {
            type: 'task',
            data: taskData,
          };
        case 'email_notification':
          return {
            type: 'emailNotification',
            data: {
              templateId: action.emailConfig?.templateId || "",
              recipients: action.emailConfig?.recipients || {
                owners: false,
                managers: false,
                from: [],
                customEmails: []
              },
              massEmail: action.emailConfig?.massEmail || false,
              title: action.emailConfig?.title || "Email Notification",
              ...action.emailConfig
            },
          };
        case 'field_update':
          const update = action.fieldUpdateConfig?.updates?.[0] || action.fieldUpdateConfig;
          return {
            type: 'setValue',
            data: {
              field: update?.field || "",
              value: update?.value || "",
              operation: update?.operation || 'set',
              ...update
            },
          };
        default:
          return {
            type: action.type,
            data: action.data || {},
          };
      }
    });
  };

  const fetchWorkflowData = async (workflowId) => {
    if (!workflowId) {
      console.error("No workflow ID provided");
      return;
    }

    try {
      setIsLoading(true);

      const response = await getApi("api/workflows/", workflowId);
      const fetchedData = response?.data;

      const workflowData = fetchedData?.data || fetchedData;

      if (!workflowData) {
        throw new Error("No workflow data received");
      }

      setOriginalWorkflowData(workflowData);

      setEditableTitle(workflowData.name || "");
      setEditableDescription(workflowData.description || "");

      if (workflowData.module) {
        await fetchModuleFields(workflowData.module);
      }

      setFormData({
        ruleName: workflowData.name || "",
        when: workflowData.trigger?.type || "",
        moduleName: workflowData.module || "",
        conditions: workflowData.targetCriteria?.conditions || [],
        actions: transformActionsToFormData(workflowData.actions || []),
      });

      setIsActive(workflowData.isActive ?? true);

      const applyToAll = workflowData.targetCriteria?.applyToAll ?? true;
      setIsConditionSelected(!applyToAll);
      setConditionOption(applyToAll ? "all" : "conditions");

      if (workflowData.targetCriteria?.conditions && workflowData.targetCriteria.conditions.length > 0) {
        const transformedConditions = workflowData.targetCriteria.conditions.map((condition, index) => ({
          condition: {
            fieldName: condition.field || "",
            operator: condition.operator || "",
            value: condition.value || "",
          },
          logicalOperator: index === 0 ? null : condition.logicalOperator || "AND",
        }));
        setConditionsWithOperators(transformedConditions);
        setShowActions(true);
      } else {
        setConditionsWithOperators([
          {
            condition: { fieldName: "", operator: "", value: "" },
            logicalOperator: null,
          },
        ]);
        if (applyToAll) {
          setShowActions(true);
        }
      }

      localStorage.setItem("workflowRuleData", JSON.stringify({
        ruleName: workflowData.name || "Edit Workflow Rule",
        module: workflowData.module || "",
        description: workflowData.description || "",
      }));

    } catch (error) {
      console.error("Error fetching workflow data:", error);
      toast({
        title: "Error",
        description: error?.response?.data?.message || error.message || "Failed to fetch workflow data",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      navigate("/crm/workflow-rules");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const workflowIdToFetch = id || location.state?.id;

    if (isEditMode && workflowIdToFetch) {
      fetchWorkflowData(workflowIdToFetch);
    }
  }, [isEditMode, id, location.state?.id]);

  useEffect(() => {
    if (!isEditMode && workflowRule.module) {
      fetchModuleFields(workflowRule.module);
    }
  }, [workflowRule.module, isEditMode]);

  const fetchEmailTemplates = async (currentPage, pageSize, sortKey = sortColumn, order = sortOrder, searchTerm = "") => {
    try {
      let endpoint =
        user?.role === "superAdmin"
          ? `api/workflows/email-templates?page=${currentPage}&limit=${pageSize}`
          : `api/workflows/email-templates?createBy=${user?._id || (() => {
            console.warn("User ID is undefined, using fallback value.");
            return "unknown";
          })()}&page=${currentPage}&limit=${pageSize}`;
      if (sortKey) {
        const sortParam = order === "desc" ? `-${sortKey}` : sortKey;
        endpoint += `&sort=${sortParam}`;
      }
      if (searchTerm) {
        endpoint += `&search=${encodeURIComponent(searchTerm)}`;
      }

      const result = await getApi(endpoint);
      const templates = result?.data?.data?.templates || [];
      setEmailTableData(templates);
      setMetadata(result?.data?.data?.pagination || {});
      const templateOptions = templates.map(item => ({
        value: item._id,
        label: item.name,
      }));

      setFields(prev =>
        prev.map(field =>
          field.key === "template"
            ? { ...field, options: templateOptions }
            : field
        )
      );
    } catch (error) {
      console.error("Failed to fetch reporting data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUserData = async () => {
    try {
      const result = await getApi("api/user/");

      const users = result?.data?.data || result?.data || [];

      const templateOptions = users.map(item => ({
        value: item._id,
        label: `${item.firstName} ${item.lastName}`.trim() || item.username,
      }));


      setTaskFields(prev => {
        const updatedFields = prev.map(field =>
          field.key === "assignedTo"
            ? { ...field, options: templateOptions }
            : field
        );
        return updatedFields;
      });
    } catch (error) {
      console.error("Failed to fetch user data", error);
    }
  };
  useEffect(() => {
    fetchEmailTemplates(currentPage, pageSize, sortColumn, sortOrder, searchbox);
    fetchUserData()
  }, []);
  const handleSearchChange = (term) => {
    const pageToFetch = term?.trim() === "" ? currentPage : 1;
    fetchEmailTemplates(pageToFetch, pageSize, sortColumn, sortOrder, term);
  };
  const handleSortChange = (accessorKey) => {
    let newSortOrder = 'asc';

    if (sortColumn === accessorKey) {
      newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
    }

    setSortColumn(accessorKey);
    setSortOrder(newSortOrder);

    fetchEmailTemplates(currentPage, pageSize, accessorKey, newSortOrder);
  };

  const handleTitleSave = () => {
    setIsEditingTitle(false);
    setOriginalWorkflowData(prev => {
      const updated = { ...prev, name: editableTitle };
      return updated;
    });
  };

  const handleDescriptionSave = () => {
    setIsEditingDescription(false);
    setOriginalWorkflowData(prev => {
      const updated = { ...prev, description: editableDescription };
      return updated;
    });
  };

  const handleTitleCancel = () => {
    setIsEditingTitle(false);
    setEditableTitle(originalWorkflowData?.name || "");
  };

  const handleDescriptionCancel = () => {
    setIsEditingDescription(false);
    setEditableDescription(originalWorkflowData?.description || "");
  };

  const handleTitleToggle = () => {
    if (isEditingTitle) {
      handleTitleSave();
    } else {
      setIsEditingTitle(true);
    }
  };

  const handleDescriptionToggle = () => {
    if (isEditingDescription) {
      handleDescriptionSave();
    } else {
      setIsEditingDescription(true);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "action" && (value === "setValue" || value === "task")) {
      setIsOpen(true);
    }
  };

  const handleDuplicateRule = () => {
    if (formData.actions.length > 0) {
      const duplicatedRule = { ...formData, ruleName: `${formData.ruleName} (Copy)` };
      setFormData(duplicatedRule);
      toast({ title: "Rule duplicated successfully", status: "success" });
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    let actions = [];
    (formData.actions || []).forEach((action) => {
      if (!action || !action.type) return;

      if (action.type === "task") {

        const taskConfig = {};

        if (action.data?.title && action.data.title.trim() !== "") {
          taskConfig.title = action.data.title;
        }
        if (action.data?.description && action.data.description.trim() !== "") {
          taskConfig.description = action.data.description;
        }
        if (action.data?.priority && action.data.priority !== "") {
          taskConfig.priority = action.data.priority;
        }
        if (action.data?.dueDate && action.data.dueDate !== "") {
          taskConfig.dueDate = formatDateForAPI(action.data.dueDate);
        }
        if (action.data?.assignedTo && action.data.assignedTo !== "") {
          taskConfig.assignedTo = action.data.assignedTo;
        }

        if (Object.keys(taskConfig).length > 0) {
          const taskAction = {
            type: "task_creation",
            taskConfig: taskConfig
          };
          actions.push(taskAction);
        }
      }
      else if (action.type === "emailNotification") {
        const emailConfig = {};

        if (action.data.templateId) {
          emailConfig.templateId = action.data.templateId;
        }
        if (action.data.recipients) {
          emailConfig.recipients = action.data.recipients;
        }
        if (typeof action.data.massEmail === 'boolean') {
          emailConfig.massEmail = action.data.massEmail;
        }

        // Only include emailConfig if it has meaningful data
        if (Object.keys(emailConfig).length > 0) {
          actions.push({
            type: "email_notification",
            emailConfig: emailConfig
          });
        }

      } else if (action.type === "setValue") {
        // Only include fieldUpdateConfig if we have valid field updates
        const fieldConfig = moduleFields.find(
          (field) => field.name === action.data.field
        );

        if (fieldConfig && action.data.value !== "" && action.data.value !== null && action.data.value !== undefined) {
          const fieldUpdate = {
            field: fieldConfig.name,
            value: fieldConfig.type === "number"
              ? parseFloat(action.data.value)
              : fieldConfig.type === "boolean"
                ? action.data.value === "true"
                : action.data.value,
            operation: action.data.operation || "set",
          };

          actions.push({
            type: "field_update",
            fieldUpdateConfig: {
              updates: [fieldUpdate]
            }
          });
        }
      }
    });

    try {
      let payload = {};

      if (isEditMode) {
        // For edit mode: Build minimal payload but include required field information
        const originalWorkflow = originalWorkflowData;

        // Handle conditions - MUST include field information with correct logical operators
        if (isConditionSelected && conditionsWithOperators.length > 0) {
          const conditions = conditionsWithOperators
            .map((item, index) => {
              // Skip if any required field is missing
              if (!item.condition.fieldName || !item.condition.operator || item.condition.value === "") {
                return null;
              }

              const condition = {
                field: item.condition.fieldName, // This is critical!
                operator: item.condition.operator,
                value: item.condition.value,
              };

              // CORRECT LOGIC: For N conditions, send logical operator with positions 1 to N-1 only
              // 2 conditions: Send logical operator with position 1 (index 0) only
              // 3 conditions: Send logical operator with positions 1, 2 (index 0, 1)
              // 4 conditions: Send logical operator with positions 1, 2, 3 (index 0, 1, 2)
              // Rule: Position N (last condition) never gets logical operator
              if (index < conditionsWithOperators.length - 1 && conditionsWithOperators.length > 1) {
                // Get the logical operator from the NEXT condition in the UI (where it's stored)
                const nextCondition = conditionsWithOperators[index + 1];
                if (nextCondition?.logicalOperator) {
                  condition.logicalOperator = nextCondition.logicalOperator;
                }
              }

              return condition;
            })
            .filter(condition => condition !== null); // Remove null entries

          if (conditions.length > 0) {
            payload.targetCriteria = {
              applyToAll: false,
              conditions: conditions,
            };
          }
        } else if (!isConditionSelected) {
          payload.targetCriteria = {
            applyToAll: true,
            conditions: [],
          };
        }


        if (actions.length > 0) {
          payload.actions = actions;
        }

        if (editableTitle !== originalWorkflow?.name) {
          payload.name = editableTitle;
        }

        if (editableDescription !== originalWorkflow?.description) {
          payload.description = editableDescription || "";
        }

        if (isActive !== originalWorkflow?.isActive) {
          payload.isActive = isActive;
        }

        if (formData.when !== originalWorkflow?.trigger?.type) {
          payload.trigger = { type: formData.when };
        }

        if (formData.moduleName?.toLowerCase() !== originalWorkflow?.module?.toLowerCase()) {
          payload.module = formData.moduleName?.toLowerCase();
        }

      } else {
        // CREATE MODE: Full create payload with proper logical operator handling
        const conditions = isConditionSelected
          ? conditionsWithOperators
            .map((item, index) => {
              // Skip if any required field is missing
              if (!item.condition.fieldName || !item.condition.operator || item.condition.value === "") {
                return null;
              }

              const condition = {
                field: item.condition.fieldName,
                operator: item.condition.operator,
                value: item.condition.value,
              };

              // CORRECT LOGIC: For N conditions, send logical operator with positions 1 to N-1 only
              // 2 conditions: Send logical operator with position 1 (index 0) only
              // 3 conditions: Send logical operator with positions 1, 2 (index 0, 1)  
              // 4 conditions: Send logical operator with positions 1, 2, 3 (index 0, 1, 2)
              // Rule: Position N (last condition) never gets logical operator
              if (index < conditionsWithOperators.length - 1 && conditionsWithOperators.length > 1) {
                // Get the logical operator from the NEXT condition in the UI (where it's stored)
                const nextCondition = conditionsWithOperators[index + 1];
                if (nextCondition?.logicalOperator) {
                  condition.logicalOperator = nextCondition.logicalOperator;
                }
              }

              return condition;
            })
            .filter(condition => condition !== null)
          : [];

        payload = {
          name: workflowRule.ruleName,
          description: workflowRule.description || "",
          module: workflowRule.module.toLowerCase(),
          trigger: { type: formData.when },
          targetCriteria: {
            applyToAll: !isConditionSelected,
            conditions: conditions,
          },
          actions,
          isActive,
          priority: 10,
        };

      }


      const hasEmptyFieldConfigs = payload.actions?.some(action =>
        action.type === 'field_update' &&
        (!action.fieldUpdateConfig?.updates || action.fieldUpdateConfig.updates.length === 0)
      );

      if (hasEmptyFieldConfigs) {
        console.warn('Warning: Empty fieldUpdateConfig detected, filtering out...');
        payload.actions = payload.actions.filter(action =>
          action.type !== 'field_update' ||
          (action.fieldUpdateConfig?.updates && action.fieldUpdateConfig.updates.length > 0)
        );
      }

      if (isEditMode && Object.keys(payload).length === 0) {
        toast({
          title: "No changes detected",
          description: "Please make some changes before saving",
          status: "info",
          duration: 3000,
          isClosable: true,
        });
        setIsLoading(false);
        return;
      }

      let response;
      if (isEditMode) {
        console.log('Making PUT request to:', `api/workflows/${workflowId}`);
        response = await putApi(`api/workflows/${workflowId}`, payload);
      } else {
        response = await postApi("api/workflows", payload);
      }

      toast({
        title: `Workflow rule ${isEditMode ? 'updated' : 'created'} successfully`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      localStorage.removeItem("workflowRuleData");
      navigate("/crm/workflow-rules");

    } catch (error) {
      console.error("API Error:", error);

      let errorDescription = "";

      if (error.response) {
        const status = error.response.status;
        const data = error.response.data;

        if (status === 400) {
          errorDescription = data?.message || data?.error || "Please check your workflow configuration";
        } else if (status === 404) {
          errorDescription = "The workflow you're trying to edit may have been deleted";
        } else if (status === 500) {
          errorDescription = "Please try again later or contact support";
        } else {
          errorDescription = data?.message || data?.error || "Please try again";
        }
      } else if (error.request) {
        errorDescription = "Please check your internet connection and try again";
      } else {
        errorDescription = "Please try again";
      }

      toast({
        title: `Workflow ${isEditMode ? 'update' : 'creation'} failed`,
        description: errorDescription,
        status: "error",
        duration: 5000,
        isClosable: true,
      });


    } finally {
      setIsLoading(false);
    }
  };

  const setValueFields = [
    {
      key: "field",
      label: "Field to update",
      type: "select",
      options: moduleFields.map((field) => ({
        value: field.name,
        label: field.label,
      })),
      placeholder: "Select field",
    },
    {
      key: "value",
      label: "New Value",
      type: "text",
      placeholder: "Enter value",
    },
  ];

  const handleSubmitSelections = (rows) => {

    const updatedEmailConfigs = rows.map((row) => ({
      templateId: row._id,
      recipients: {
        owners: row.recipientsData?.owner || false,
        managers: row.recipientsData?.manager || false,
        from: row.recipientsData?.fromData || [],
        customEmails: row.recipientsData?.customEmails || [],
      },
      massEmail: row.massEmail || false,
    }));

    setAssociatedEmailNotifications(updatedEmailConfigs);
    setSelectedEmailRows(rows);

    setFormData((prev) => ({
      ...prev,
      actions: [
        ...(prev.actions || []),
        ...updatedEmailConfigs.map((config) => ({
          type: "emailNotification",
          data: config,
        })),
      ],
    }));
  };

  const currentModuleName = isEditMode ? originalWorkflowData?.module : workflowRule.module;

  if (isLoading && isEditMode && !originalWorkflowData) {
    return (
      <Box textAlign="center" py={10}>
        <Text>Loading workflow data...</Text>
      </Box>
    );
  }

  return (
    <>
      <Flex justifyContent={"space-between"} alignItems={"flex-start"}>
        <VStack align="start" mb={4} mt={2} spacing={3} width="100%">
          <HStack width="100%">
            <Image
              onClick={() => navigate(-1)}
              cursor={"pointer"}
              src={BackIcon}
              alt=""
              height={"18px"}
              width={"18px"}
            />

            {isEditMode ? (
              <HStack spacing={2} flex={1}>
                {isEditingTitle ? (
                  <HStack spacing={2} flex={1}>
                    <Input
                      value={editableTitle}
                      onChange={(e) => setEditableTitle(e.target.value)}
                      fontSize="lg"
                      fontWeight="bold"
                      size="md"
                      flex={1}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleTitleToggle();
                        } else if (e.key === 'Escape') {
                          handleTitleCancel();
                        }
                      }}
                      onBlur={handleTitleToggle}
                      autoFocus
                    />
                    <Image
                      src={EditIcon}
                      alt="Save Title"
                      height="16px"
                      width="16px"
                      cursor="pointer"
                      onClick={handleTitleToggle}
                    />
                  </HStack>
                ) : (
                  <HStack spacing={2}>
                    <Text className="workflowPageTitle">
                      Edit Workflow Rule: {editableTitle || 'Loading...'}
                    </Text>
                    <Image
                      src={EditIcon}
                      alt="Edit Title"
                      height="16px"
                      width="16px"
                      cursor="pointer"
                      onClick={handleTitleToggle}
                    />
                  </HStack>
                )}
              </HStack>
            ) : (
              <Text className="workflowPageTitle">
                {workflowRule.ruleName || "Create Workflow Rule"}
              </Text>
            )}
          </HStack>

          {isEditMode && (
            <Box ml={6} width="100%">
              <Text fontSize="sm" color="gray.600" mb={1}>
                Description:
              </Text>
              {isEditingDescription ? (
                <HStack spacing={2} width="100%">
                  <Input
                    value={editableDescription}
                    onChange={(e) => setEditableDescription(e.target.value)}
                    placeholder="Enter workflow description"
                    size="sm"
                    width="500px"
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleDescriptionToggle();
                      } else if (e.key === 'Escape') {
                        handleDescriptionCancel();
                      }
                    }}
                    onBlur={handleDescriptionToggle}
                    autoFocus
                  />
                  <Image
                    src={EditIcon}
                    alt="Save Description"
                    height="14px"
                    width="14px"
                    cursor="pointer"
                    onClick={handleDescriptionToggle}
                  />
                </HStack>
              ) : (
                <HStack spacing={2}>
                  <Text fontSize="sm" color="gray.700" maxWidth="500px">
                    {editableDescription || 'No description provided'}
                  </Text>
                  <Image
                    src={EditIcon}
                    alt="Edit Description"
                    height="14px"
                    width="14px"
                    cursor="pointer"
                    onClick={handleDescriptionToggle}
                  />
                </HStack>
              )}
            </Box>
          )}
        </VStack>
      </Flex>

      <Box className="workflowRuleContainer">
        {/* Flow Diagram */}
        <Flex direction="column" align="center" gap={6} mb={6}>
          {/* When Block */}
          <Box className="workflowBlock">
            <Text className="blockLegend">{constant.when}</Text>
            {formData?.when ? (
              <Flex align="center" justify="space-between" w="100%">
                <Text className="workflowWhenText">
                  {constant.ruleExecuted} <b>{currentModuleName || "..."}</b>{" "}
                  is <b>{formData.when}</b>.
                </Text>

                <Image
                  onClick={() => setFormData((prev) => ({ ...prev, when: "" }))}
                  src={EditIcon}
                  height={"22px"}
                  width={"22px"}
                  cursor={"pointer"}
                  alt=""
                />
              </Flex>
            ) : (
              <Box className="workflowSelect">
                <Select
                  name="when"
                  value={formData.when}
                  onChange={handleChange}
                  placeholder="Select event"
                  mt={2}
                >
                  {workflowOptions?.eventOptions.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </Select>
              </Box>
            )}
          </Box>
          <ArrowDownIcon boxSize={6} />

          {/* Condition Block */}
          <Box className="workflowBlock">
            <Text className="blockLegend">Condition </Text>
            <Box className="workflowSelectOptions">
              <Text className="workflowWhenText">
                Which {currentModuleName} would you like to apply the rule to?
              </Text>
              <RadioGroup
                onChange={(value) => {
                  setConditionOption(value);
                  setIsConditionSelected(value === "conditions");
                  setShowActions(false);
                }}
                value={conditionOption}
                isDisabled={!formData.when}
                className="workflowRadioGroup"
              >
                <HStack spacing={4}>
                  <Radio value="conditions">{constant.modulesMatching}</Radio>
                  <Radio value="all">{constant.allModules}</Radio>
                </HStack>
              </RadioGroup>
            </Box>

            {isConditionSelected && (
              <>
                <Box className="workflowConditionsWrapper" mt={7}>
                  <Flex
                    direction="column"
                    align="start"
                    gap={0}
                    className="conditionRow"
                  >
                    {conditionsWithOperators.map((item, index) => (
                      <React.Fragment key={index}>
                        <Box className="conditionBlock" width="100%">
                          <Flex gap={2} alignItems={"center"}>
                            <Box className="conditionCountBox" me={"12px"}>
                              <Text className="conditionCountText">
                                {index + 1}
                              </Text>
                            </Box>
                            <Select
                              name="fieldName"
                              value={item.condition.fieldName}
                              onChange={(e) => {
                                const updatedConditions = [...conditionsWithOperators];
                                updatedConditions[index].condition.fieldName = e.target.value;

                                updatedConditions[index].condition.operator = "";
                                updatedConditions[index].condition.value = "";

                                setConditionsWithOperators(updatedConditions);
                              }}
                              placeholder="Select field"
                              mr={2}
                            >
                              {moduleFields.map((field) => (
                                <option key={field.name} value={field.name}>
                                  {field.label}
                                </option>
                              ))}
                            </Select>

                            <Select
                              name="operator"
                              value={item.condition.operator}
                              onChange={(e) => {
                                const updatedConditions = [
                                  ...conditionsWithOperators,
                                ];
                                updatedConditions[index].condition.operator =
                                  e.target.value;
                                setConditionsWithOperators(updatedConditions);
                              }}
                              placeholder="Select operator"
                              mr={2}
                            >
                              {workflowOptions.operatorOptions.map(
                                ({ value, label }) => (
                                  <option key={value} value={value}>
                                    {label}
                                  </option>
                                )
                              )}
                            </Select>

                            {(() => {
                              const selectedField = moduleFields.find(
                                (field) => field.name === item.condition.fieldName
                              );
                              if (selectedField?.type === "select") {
                                return (
                                  <Select
                                    name="value"
                                    value={item.condition.value}
                                    onChange={(e) => {
                                      const updatedConditions = [...conditionsWithOperators];
                                      updatedConditions[index].condition.value = e.target.value;
                                      setConditionsWithOperators(updatedConditions);
                                    }}
                                    placeholder="Select value"
                                    mr={2}
                                  >
                                    {selectedField.options.map((option) => (
                                      <option key={option._id || option} value={option.value || option}>
                                        {option.name || option}
                                      </option>
                                    ))}
                                  </Select>
                                );
                              } else if (selectedField?.type === "number") {
                                return (
                                  <Input
                                    name="value"
                                    type="number"
                                    value={item.condition.value}
                                    onChange={(e) => {
                                      const updatedConditions = [...conditionsWithOperators];
                                      updatedConditions[index].condition.value = e.target.value;
                                      setConditionsWithOperators(updatedConditions);
                                    }}
                                    placeholder="Enter number"
                                    mr={2}
                                  />
                                );
                              } else {
                                return (
                                  <Input
                                    name="value"
                                    type="text"
                                    value={item.condition.value}
                                    onChange={(e) => {
                                      const updatedConditions = [...conditionsWithOperators];
                                      updatedConditions[index].condition.value = e.target.value;
                                      setConditionsWithOperators(updatedConditions);
                                    }}
                                    placeholder="Enter value"
                                    mr={2}
                                  />
                                );
                              }
                            })()}

                            {conditionsWithOperators.length > 1 && (
                              <Image
                                src={DeleteIcon}
                                alt="Delete"
                                height="24px"
                                width="24px"
                                cursor="pointer"
                                onClick={() => {
                                  const updated = [...conditionsWithOperators];
                                  updated.splice(index, 1);
                                  setConditionsWithOperators(updated);
                                }}
                              />
                            )}
                          </Flex>
                        </Box>

                        {index < conditionsWithOperators.length - 1 && (
                          <Box className="logicalOperatorBox">
                            <Flex direction="column" align="center">
                              <Box height="14px" borderLeft="1px solid #ccc" />
                              <Select
                                value={
                                  conditionsWithOperators[index + 1]
                                    .logicalOperator || "AND"
                                }
                                onChange={(e) => {
                                  const updated = [...conditionsWithOperators];
                                  updated[index + 1].logicalOperator =
                                    e.target.value;
                                  setConditionsWithOperators(updated);
                                }}
                                size="sm"
                                width="80px"
                                textAlign="center"
                              >
                                <option value="AND">AND</option>
                                <option value="OR">OR</option>
                              </Select>
                              <Box height="14px" borderLeft="1px solid #ccc" />
                            </Flex>
                          </Box>
                        )}
                      </React.Fragment>
                    ))}
                  </Flex>
                </Box>
              </>
            )}

            <Flex
              className="addConditionButton"
              mt={4}
              justify="space-between"
              align="center"
            >
              {isConditionSelected ? (
                <Text
                  className="ctaColor"
                  cursor={
                    conditionsWithOperators.every(
                      (item) =>
                        item.condition.fieldName &&
                        item.condition.operator &&
                        item.condition.value
                    )
                      ? "pointer"
                      : "not-allowed"
                  }
                  opacity={
                    conditionsWithOperators.every(
                      (item) =>
                        item.condition.fieldName &&
                        item.condition.operator &&
                        item.condition.value
                    )
                      ? 1
                      : 0.5
                  }
                  onClick={() => {
                    const allConditionsComplete = conditionsWithOperators.every(
                      (item) =>
                        item.condition.fieldName &&
                        item.condition.operator &&
                        item.condition.value
                    );

                    if (allConditionsComplete) {
                      setConditionsWithOperators((prev) => [
                        ...prev,
                        {
                          condition: { fieldName: "", operator: "", value: "" },
                          logicalOperator: "AND",
                        },
                      ]);
                    }
                  }}
                >
                  + Add Condition
                </Text>
              ) : (
                <Box />
              )}

              <Button
                className="theme-btn2"
                variant="brand"
                isDisabled={
                  (isConditionSelected &&
                    conditionsWithOperators.some(
                      (item) =>
                        !item.condition.fieldName ||
                        !item.condition.operator ||
                        !item.condition.value
                    )) ||
                  !formData?.when
                }
                onClick={() => {
                  if (isConditionSelected) {
                    setFormData((prev) => ({
                      ...prev,
                      conditions: conditionsWithOperators.map((item) => ({
                        ...item.condition,
                        logicalOperator: item.logicalOperator,
                      })),
                    }));
                  } else {
                    setFormData((prev) => ({
                      ...prev,
                      conditions: [],
                    }));
                  }
                  setShowActions(true);
                }}
              >
                Continue
              </Button>
            </Flex>
          </Box>

          {showActions && (
            <>
              <ArrowDownIcon boxSize={6} />
              {/* Action Block */}
              <Box className="workflowBlock">
                <Text className="blockLegend">Action</Text>
                <Box className="workflowActionSelect">
                  {/* Initial Dropdown OR +Add Action Dropdown */}
                  {(formData.actions.length === 0 ||
                    pendingActionType === "selecting") && (
                      <Select
                        placeholder="Select action to add"
                        onChange={(e) => {
                          const type = e.target.value;
                          if (type === "emailNotification") {
                            setPendingActionType("emailNotification")
                            setIsTableModalOpen(true);
                            setIsOpen(false)

                            return;
                          }
                          const newAction = { type, data: {} };
                          setFormData((prev) => ({
                            ...prev,
                            actions: [...(prev.actions || []), newAction],
                          }));
                          setPendingActionType(type);
                          setEditActionIndex(formData.actions.length);
                          setIsOpen(true);
                          e.target.selectedIndex = 0;
                        }}
                        mt={2}
                      >
                        {workflowOptions?.actionValue.map(({ value, label }) => (
                          <option key={value} value={value}>
                            {label}
                          </option>
                        ))}
                      </Select>
                    )}

                  {/* Action Cards */}
                  {(formData.actions || []).map(
                    (action, index) =>
                      Object.keys(action.data || {}).length > 0 && (
                        <Box
                          key={index}
                          mt={4}
                          p={4}
                          border="1px solid #e2e8f0"
                          borderRadius="md"
                          className="actionDetailsBox"
                          w="100%"
                        >
                          <Flex justify="space-between" align="flex-start">
                            <Box>
                              <Text fontWeight="bold" mb={1}>
                                Instant Action {index + 1}
                              </Text>
                              <Text fontSize="sm" color="gray.600">
                                {action.type === "task" &&
                                  `Task: ${action.data?.title || "No Subject"}`}
                                {action.type === "emailNotification" &&
                                  `Email Notification
                                  `}
                                {action.type === "setValue" &&
                                  `Update ${action.data?.field || "Field"} to ${action.data?.value || "Value"
                                  }`}
                              </Text>
                            </Box>
                            <HStack spacing={3}>
                              <Image
                                src={EditIcon}
                                alt="Edit"
                                height="20px"
                                width="20px"
                                cursor="pointer"
                                onClick={() => {
                                  if (action.type === "emailNotification") {
                                    const emailAction = formData.actions[index];
                                    setEditModeEmailData(emailAction?.data || null);
                                    setEditActionIndex(index);
                                    setPendingActionType(action.type);
                                    setIsTableModalOpen(true);
                                  } else {
                                    setEditActionIndex(index);
                                    setPendingActionType(action.type);
                                    setIsOpen(true);
                                  }
                                }}
                              />
                              <Image
                                src={DeleteIcon}
                                alt="Delete"
                                height="20px"
                                width="20px"
                                cursor="pointer"
                                onClick={() => {
                                  const updated = [...formData.actions];
                                  updated.splice(index, 1);
                                  setFormData((prev) => ({
                                    ...prev,
                                    actions: updated,
                                  }));
                                }}
                              />
                            </HStack>
                          </Flex>
                        </Box>
                      )
                  )}

                  {/* Add Action Button (only shown if actions exist) */}
                  {formData.actions.length > 0 &&
                    pendingActionType !== "selecting" && (
                      <Text
                        className="ctaColor"
                        cursor="pointer"
                        mt={4}
                        onClick={() => setPendingActionType("selecting")}
                      >
                        + Add Action
                      </Text>
                    )}
                </Box>
              </Box>
            </>
          )}
        </Flex>

        {/* Submit Button */}
        <Flex justify="space-between" mt={6}>
          <Flex align="center">
            <Text mr={2}>{constant.activateRule}</Text>
            <Switch
              isChecked={isActive}
              onChange={() => setIsActive((prev) => !prev)}
              colorScheme={isActive ? "brand" : "red"}
              isDisabled={
                formData.actions.length === 0 ||
                formData.actions.some(
                  (action) => !action.data || Object.keys(action.data).length === 0
                )
              }
              className="activateBtn"
              mr={2}
            />
          </Flex>
          <Flex gap={"8px"}>
            <Button
              variant="outline"
              className="theme-btn2 cancelBtn"
              onClick={() => navigate("/crm/workflow-rules")}
            >
              {constant.cancel}
            </Button>
            <Button
              className="theme-btn1"
              variant={"brand"}
              isLoading={isLoading}
              isDisabled={formData.actions.length === 0 || formData.actions.some(action => !action.data || Object.keys(action.data).length === 0)}
              onClick={handleSubmit}
            >
              {isEditMode ? constant.update || "Update" : constant.save}
            </Button>
          </Flex>
        </Flex>
      </Box>

      <DynamicFormModal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
          setPendingActionType(null);

          setFormData((prev) => ({
            ...prev,
            actions: prev.actions.filter((action) => Object.keys(action.data).length > 0),
          }));

          setEditActionIndex(null);
        }}
        initialValues={
          editActionIndex !== null
            ? formData.actions[editActionIndex]?.data
            : {}
        }
        title={
          pendingActionType === "task"
            ? "Task details"
            : pendingActionType === "emailNotification"
              ? "Email Notification Details"
              : "Update Field"
        }
        fields={
          pendingActionType === "task"
            ? taskFields
            : pendingActionType === "setValue"
              ? setValueFields.map((field) => {
                if (field.key === "value") {
                  const selectedFieldName = formData.actions[editActionIndex]?.data?.field;
                  const selectedField = moduleFields.find((field) => field.name === selectedFieldName);
                  if (selectedField?.type === "select") {
                    return {
                      ...field,
                      type: "select",
                      options: selectedField.options.map((option) => ({
                        value: option.value || option,
                        label: option.name || option,
                      })),
                    };
                  } else if (selectedField?.type === "number") {
                    return {
                      ...field,
                      type: "number",
                    };
                  }
                }
                return field;
              })
              : fields
        }
        onFieldChange={(updatedField, updatedValue) => {
          if (updatedField === "field") {
            const selectedField = moduleFields.find((field) => field.name === updatedValue);
            const updatedFields = setValueFields.map((field) => {
              if (field.key === "value") {
                if (selectedField?.type === "select") {
                  return {
                    ...field,
                    type: "select",
                    options: selectedField.options.map((option) => ({
                      value: option.value || option,
                      label: option.name || option,
                    })),
                  };
                } else if (selectedField?.type === "number") {
                  return {
                    ...field,
                    type: "number",
                  };
                }
              }
              return field;
            });
            setFields(updatedFields);
          }
        }}
        onSubmit={(data) => {
          const fieldConfig = moduleFields.find((field) => field.name === data.field);
          if (fieldConfig) {
            data.value =
              fieldConfig.type === "number"
                ? parseFloat(data.value)
                : fieldConfig.type === "boolean"
                  ? data.value === "true"
                  : data.value;
          }

          setFormData((prev) => {
            const updatedActions = [...(prev.actions || [])];
            if (editActionIndex !== null) {
              updatedActions[editActionIndex] = {
                type: pendingActionType,
                data,
              };
            } else {
              updatedActions.push({
                type: pendingActionType,
                data,
              });
            }
            return {
              ...prev,
              actions: updatedActions,
            };
          });

          setIsOpen(false);
          setEditActionIndex(null);
          setPendingActionType(null);
        }}
        moduleFields={moduleFields}
      />
      <DymanicTableModal
        isTableModalOpen={isTableModalOpen}
        onTableModalClose={() => {
          setIsTableModalOpen(false);
          setEditActionIndex(null);
          setPendingActionType(null);
          setEditModeEmailData(null);
        }}
        handleNewEmailNotification={() => {
          setIsOpen(true);
          setIsTableModalOpen(false);
        }}
        dataFromParent={emailTableData}
        editModeData={editModeEmailData}
        onSubmitSelections={(rows) => {
          const updatedEmailConfigs = rows.map((row) => ({
            templateId: row._id,
            recipients: {
              owners: row.recipientsData?.owner || false,
              managers: row.recipientsData?.manager || false,
              from: row.recipientsData?.fromData || [],
              customEmails: row.recipientsData?.customEmails || [],
            },
            massEmail: row.massEmail || false,
          }));

          setAssociatedEmailNotifications(updatedEmailConfigs);
          setSelectedEmailRows(rows);

          setFormData((prev) => {
            const updatedActions = [...(prev.actions || [])];
            if (editActionIndex !== null) {
              updatedActions[editActionIndex] = {
                type: "emailNotification",
                data: updatedEmailConfigs[0],
              };
            } else {
              updatedActions.push({
                type: "emailNotification",
                data: updatedEmailConfigs[0],
              });
            }
            return { ...prev, actions: updatedActions };
          });

          setIsTableModalOpen(false);
          setEditActionIndex(null);
          setPendingActionType(null);
          setEditModeEmailData(null);
        }}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        fetchData={fetchEmailTemplates}
        pageSize={pageSize}
        setPageSize={setPageSize}
        metadata={metadata}
        sortOrder={sortOrder}
        handleSortChange={handleSortChange}
        handleSearchChange={handleSearchChange}
        searchbox={searchbox}
        setSearchbox={setSearchbox}
        moduleFields={moduleFields}
      />
    </>
  );
};

export default CreateWorkflowRule;